import { TaxAndAdviceMomentsFields } from 'src/non-financial-data/v2/sections/fields/TaxAndAdviceMomentsFields';
import IndividualEntityForm from '../IndividualEntityForm';

export default function TaxAndAdviceMomentsV2() {
  return (
    <IndividualEntityForm title="Tax & advice moments">
      <TaxAndAdviceMomentsFields />
    </IndividualEntityForm>
  );
}
